let e;
function i() {
  return typeof document == "undefined" ? !1 : (e === void 0 && ("matchMedia" in window ? e = window.matchMedia("(pointer:coarse)").matches : e = !1), e);
}
let n;
function t() {
  return typeof document == "undefined" ? 1 : (n === void 0 && (n = "chrome" in window ? window.devicePixelRatio : 1), n);
}
export {
  i as ensureMaybeTouch,
  t as ensureWheelScale
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/virtual-list/src/config.js
// module id = 1745
// module chunks = 41